// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".monetise-spinner_wrapper[data-v-8d5d6f5a]{width:100%;height:calc(100vh - 10rem);display:flex;align-items:center;justify-content:center}.quotes-container-subtitle[data-v-8d5d6f5a]{text-align:center;margin-bottom:4rem;margin-top:-2rem;font-weight:400}", ""]);
// Exports
module.exports = exports;
